var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { NButton } from 'naive-ui';
import PiloteModal from '../modal/PiloteModal.vue';
import { key } from '../../../store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalButton',
    props: {
        modalMessage: {
            type: String,
            required: false,
            default: ""
        },
        onConfirm: {
            type: Function,
            required: true,
        },
        closeLabel: {
            type: String,
            required: false,
            default: ""
        },
        confirmLabel: {
            type: String,
            required: false,
            default: ""
        },
        modalTitle: {
            type: String,
            required: false,
            default: ""
        }
    },
    setup: function (__props) {
        var _this = this;
        var props = __props;
        var t = useI18n({ useScope: 'global' }).t;
        var isModalShown = ref(false);
        var store = useStore(key);
        var showModal = function (event) {
            event.stopPropagation();
            isModalShown.value = true;
        };
        var hideModal = function () {
            isModalShown.value = false;
        };
        var confirm = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hideModal();
                        return [4 /*yield*/, props.onConfirm()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(NButton), { onClick: showModal }, {
                    default: _withCtx(function () { return [
                        _renderSlot(_ctx.$slots, "default")
                    ]; }),
                    _: 3 /* FORWARDED */
                }),
                _createVNode(PiloteModal, {
                    title: __props.modalTitle,
                    show: isModalShown.value,
                    confirm: confirm,
                    "confirm-label": __props.confirmLabel,
                    close: hideModal,
                    "close-label": __props.closeLabel
                }, {
                    default: _withCtx(function () { return [
                        _createTextVNode(_toDisplayString(__props.modalMessage), 1 /* TEXT */)
                    ]; }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["title", "show", "confirm-label", "close-label"])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
